import React, { FC, InputHTMLAttributes } from 'react';

import imgUser from '../../assets/images/login/user.png'
import imgPassword from '../../assets/images/login/padlock.png'

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
}

const Input: FC<InputProps> = ({ type = 'text', placeholder, value, name, onChange, label }) => {
  const whichImage = () =>{
    if( type === "password" ) return imgPassword
    else return imgUser
  }
  return(
    <div className="flex justify-center   mt-5 md:justify-end">
      <div className="flex w-3/4 md:w-1/2 2001px:w-1/3">
        <input 
          style={{color:"white"}}
          className="block w-full p-2 outline-none bg-white bg-opacity-0 border-b-2 "
          type={type}
          placeholder={placeholder}
          value={value}
          name={name}
          id={name}
          onChange={onChange}
          required
          autoComplete="off"
        />
        <img src={whichImage()} alt="" className="img-input-field-768  mt-2"/>
      </div>
    </div>
  );
}

export default Input;